import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag: number | string;
  attachmentName: string;
  rowVersion: string;
};

const deleteAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  attachmentName,
  benefitImplementationTag,
  rowVersion,
}: Params) => {
  const response = await api.patch(
    `/benefitimplementation/attachment/delete/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}/${attachmentName}`,
    {
      rowVersion,
    }
  );
  return response.data as Attachment;
};

export function useDeleteBenefitImplementationAttachment(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitImplementations =
    useInvalidateBenefitImplementations();

  return useMutation(deleteAttachment, {
    mutationKey: MUTATION_KEYS.deleteBenefitImplementationAttachment,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitImplementations();
      }
      // queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategories });
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
